import { axios } from '@Api/axiosClient';
import type { BankWiringData } from '@Types/BankWiringData.interface';

export type { BankWiringData };

const baseUrl: string = 'api/Bank';

export const lookupBankApi = async (routingNumber: string): Promise<BankWiringData> => {
    const response = await axios.get(`${baseUrl}/LookupBank?routingNumber=${routingNumber}`);
    return response.data;
};
